import { SUMMARY_ROW_ID } from '@fourthwall/module-analytics';
export const getCsvData = (statsTableData) => {
    return statsTableData
        .filter(({ id }) => id !== SUMMARY_ROW_ID)
        .map(({ id, children, ...rest }) => rest); // removes ids and children
};
